import { PluginFunction } from "vue";
import { Store } from "vuex";
import { getModule } from "vuex-module-decorators";

import CartModule from "@/store/cart/cart";
import IndexModule from "@/store/indexPage";
import CommonModule from "@/store/common";
import PersonalModule from "@/store/personal";
import ProductModule from "@/store/product";
import CatalogModule from "@/store/catalog/catalog";
import OrdersModule from "@/store/account/orders";
import ContactsModule from "@/store/contacts";
import NotificationsModule from "@/store/notifications";
import PricesModule from "@/store/prices";
import ComplaintsModule from "@/store/complaints";

interface Props {
  store: Store<any>;
}

/* eslint-disable */
let indexModule: IndexModule;
let cartModule: CartModule;
let commonModule: CommonModule;
let personalModule: PersonalModule;
let productModule: ProductModule;
let catalogModule: CatalogModule;
let ordersModule: OrdersModule;
let contactsModule: ContactsModule;
let notificationsModule: NotificationsModule;
let pricesModule: PricesModule;
let complaintsModule: ComplaintsModule;
/* eslint-enable */

const initializeModules: PluginFunction<any> = (Vue, { store }: Props) => {
  cartModule = getModule(CartModule, store);
  indexModule = getModule(IndexModule, store);
  commonModule = getModule(CommonModule, store);
  personalModule = getModule(PersonalModule, store);
  productModule = getModule(ProductModule, store);
  catalogModule = getModule(CatalogModule, store);
  ordersModule = getModule(OrdersModule, store);
  contactsModule = getModule(ContactsModule, store);
  notificationsModule = getModule(NotificationsModule, store);
  pricesModule = getModule(PricesModule, store);
  complaintsModule = getModule(ComplaintsModule, store);
};

export {
  initializeModules,
  cartModule,
  indexModule,
  commonModule,
  personalModule,
  productModule,
  catalogModule,
  ordersModule,
  contactsModule,
  notificationsModule,
  pricesModule,
  complaintsModule,
};
